<template>
  <div class="wrapper">
    <div class="main visual-2 /enter-phone visual-10">
      <Header backRoute="/enter-email" />
      <div class="vis4-inr1">
        <h1>Enter Your Phone Number</h1>
        <form
          class="namesearch"
          id="manualsmsform"
          @submit.prevent="handleSubmit"
        >
          <label for="phone">Phone Number (required)</label><br />
          <input
            v-model="phoneNumber"
            id="phone"
            type="tel"
            placeholder="e.g. 5551234567"
            required
            maxlength="11"
            @input="onInput"
          />
          <div class="sbmt">
            <button type="submit">Next</button>
          </div>
        </form>
      </div>
      <FooterView />
    </div>
  </div>
</template>

<script>
import FooterView from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";

export default {
  components: {
    FooterView,
    Header,
  },
  name: "EnterTelephone",
  data() {
    return {
      phoneNumber: "",
    };
  },
  mounted() {
    // ✅ Restore saved phone number if it exists
    const savedPatient = JSON.parse(localStorage.getItem("patient"));
    if (savedPatient && savedPatient.phone) {
      this.phoneNumber = savedPatient.phone;
    }
  },
  methods: {
    onInput() {
      // Allow only numbers and limit to 11 digits
      this.phoneNumber = this.phoneNumber.replace(/[^0-9]/g, "").slice(0, 11);
    },
    handleSubmit() {
      if (this.phoneNumber.length < 10) {
        alert("Please enter a valid mobile number.");
        return;
      }

      // ✅ Save phone number to localStorage
      const patient = JSON.parse(localStorage.getItem("patient")) || {};
      patient.phone = this.phoneNumber;

      localStorage.setItem("patient", JSON.stringify(patient));

      // Navigate to next page
      this.$router.push({
        path: "/comunication-type",
        query: this.$route.query.code ? { code: this.$route.query.code } : {},
      });
    },
  },
};
</script>
